import script from "./ChatBox.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChatBox.vue?vue&type=script&setup=true&lang=ts"

import "./ChatBox.vue?vue&type=style&index=0&id=5796ef50&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5796ef50"]])

export default __exports__